import { Filter } from '~/shared/ui/AsyncGrid/types'

export const filters: Filter[] = [
  {
    field: 'name',
    label: 'filter.full name',
    type: 'text',
  },
  {
    field: 'email',
    label: 'filter.email',
    type: 'text',
  },
]
